import API from '@/api';

const PROVIDER_CONFIG = {
  google: { messageType: 'GOOGLE_CODE_SUCCESS' },
  facebook: { messageType: 'FACEBOOK_CODE_SUCCESS' },
};

function getRelatedOrigins() {
  const origins = new Set([window.location.origin]);
  try {
    const url = new URL(window.location.origin);
    if (url.hostname.startsWith('www.')) {
      origins.add(`${url.protocol}//${url.hostname.slice(4)}`);
    } else {
      origins.add(`${url.protocol}//www.${url.hostname}`);
    }
  } catch (_) {
    // ignore invalid origin
  }
  return [...origins];
}

export function isAllowedOAuthMessageOrigin(origin) {
  if (origin === window.location.origin) {
    return true;
  }
  return getRelatedOrigins().includes(origin);
}

function notifyOpener(messageType, code) {
  if (!window.opener || window.opener.closed) {
    return false;
  }

  getRelatedOrigins().forEach((targetOrigin) => {
    try {
      window.opener.postMessage({ type: messageType, code }, targetOrigin);
    } catch (_) {
      // ignore delivery failures for individual origins
    }
  });

  return true;
}

function completeSocialLogin(provider, code) {
  return new Promise((resolve, reject) => {
    API.socialLogin(
      { provider, accessToken: code },
      (response) => {
        if (response.token) {
          localStorage.setItem('isLoggedin', response.token);
          localStorage.setItem('user', JSON.stringify(response.user));
          localStorage.setItem('isAuthenticatedToAccessWebsite', 'true');
          if (response.permissions) {
            localStorage.setItem('userPermissions', JSON.stringify(response.permissions));
          }
          resolve(response);
          return;
        }
        reject(new Error(response.message || 'Login failed'));
      },
      (err) => {
        reject(new Error(err?.data?.message || 'Something went wrong during login.'));
      }
    );
  });
}

function redirectAfterLogin() {
  const originalUrl = localStorage.getItem('originalUrl');
  if (originalUrl) {
    localStorage.removeItem('originalUrl');
    window.location.href = originalUrl;
    return;
  }
  window.location.href = '/';
}

let oauthHandled = false;

export function handleSocialOAuthCallback(provider) {
  if (oauthHandled) {
    return Promise.resolve({ via: 'already-handled' });
  }
  oauthHandled = true;

  const config = PROVIDER_CONFIG[provider];
  const params = new URLSearchParams(window.location.search);
  const code = params.get('code');
  const error = params.get('error');

  if (error) {
    return Promise.reject(new Error(`Login cancelled: ${error}`));
  }

  if (!code) {
    return Promise.reject(new Error('Login failed: authorization code missing.'));
  }

  if (notifyOpener(config.messageType, code)) {
    setTimeout(() => window.close(), 300);
    return Promise.resolve({ via: 'postMessage' });
  }

  return completeSocialLogin(provider, code).then((response) => {
    redirectAfterLogin();
    return { via: 'direct', response };
  });
}
